export default __webpack_public_path__ + "static/media/normal-available_loan.d4d52ddf.jpg";